<template>
    <Loader :isLoading="isLoading" :position="'fixed'" />
    <ConfirmDialog></ConfirmDialog>
    <Toast/>
    <template v-if="webData">
        <router-view />
    </template>
    <div v-if="!webData && !isLoading" class="text-center pt-5">
        <img src="@/assets/img/connect-error.png"/>
        <h3>Bağlantı sırasında bir hata oluştu.</h3>
    </div>
</template>

<script>

export default {
    name: 'App',
    data(){
        return {
            isLoading : false
        }
    },
    async created(){
        this.isLoading = true;
        await this.$store.dispatch('auth/checkAuthToken');
        await this.$store.dispatch("core/getWebData").then(res=>{
            window.document.title = res.pageTitle;
            document.querySelector("meta[property='og:title']").setAttribute("content",res.pageTitle);
            document.querySelector("meta[name='description']").setAttribute("content",res.description);
            document.querySelector("meta[property='og:description']").setAttribute("content",res.description);
            if(res.redirect){
                window.location.href = res.redirect;
            }
        }).catch(()=>{});
        this.isLoading = false;
    },
    computed: {
        webData() {
            return this.$store.getters['core/webData'];
        }
    }
}
</script>
